import { Navigate, useLocation } from "react-router-dom";

const CanonicalRedirect = () => {
  const { pathname, search, hash } = useLocation();

  if (pathname.length > 1 && pathname.endsWith("/")) {
    return (
      <Navigate
        to={`${pathname.replace(/\/+$/, "")}${search}${hash}`}
        replace
      />
    );
  }

  return null;
};

export default CanonicalRedirect;
